import { render, staticRenderFns } from "./Xenon.vue?vue&type=template&id=51fa7b89&scoped=true&"
import script from "./Xenon.vue?vue&type=script&lang=js&"
export * from "./Xenon.vue?vue&type=script&lang=js&"
import style0 from "./Xenon.vue?vue&type=style&index=0&id=51fa7b89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fa7b89",
  null
  
)

export default component.exports